import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  EmailReaderCompaniesResponseDataSchema,
  EmailReaderMessagesQuerySchema,
  EmailReaderMessagesResponseDataSchema,
  EmailReaderThreadResponseDataSchema,
} from "schema"
import { z } from "zod"

type MessagesQuery = z.input<typeof EmailReaderMessagesQuerySchema>
type CompaniesResponse = DataResponse<z.infer<typeof EmailReaderCompaniesResponseDataSchema>>
type MessagesResponse = DataResponse<z.infer<typeof EmailReaderMessagesResponseDataSchema>>
type ThreadResponse = DataResponse<z.infer<typeof EmailReaderThreadResponseDataSchema>>

const noCacheHeaders = { "Cache-Control": "no-cache", Pragma: "no-cache" }

export const emailReaderCompaniesQuery = (basePath: string) =>
  queryOptions({
    queryKey: ["emailReaderCompanies", basePath],
    queryFn: async () => {
      const { data } = await axios.get<CompaniesResponse>(`${basePath}/companies`, {
        headers: noCacheHeaders,
      })
      return data.data
    },
  })

export const emailReaderMessagesQuery = (basePath: string, query: MessagesQuery | undefined) =>
  queryOptions({
    queryKey: ["emailReaderMessages", basePath, query],
    enabled: query !== undefined,
    queryFn: async () => {
      const { data } = await axios.get<MessagesResponse>(`${basePath}/messages`, {
        params: query,
        headers: noCacheHeaders,
      })
      return data.data
    },
    refetchOnWindowFocus: false,
  })

export const emailReaderThreadQuery = (
  basePath: string,
  { integrationId, threadId }: { integrationId: string | undefined; threadId: string | undefined },
) =>
  queryOptions({
    queryKey: ["emailReaderThread", basePath, integrationId, threadId],
    enabled: integrationId !== undefined && threadId !== undefined,
    queryFn: async () => {
      const { data } = await axios.get<ThreadResponse>(`${basePath}/threads/${threadId}`, {
        params: { integrationId },
        headers: noCacheHeaders,
      })
      return data.data
    },
  })
